import * as React from "react";
import { Message } from "../../types";
import PreviewCloseButton from "./PreviewCloseButton";
import PreviewMessage from "./PreviewMessage";
import PreviewMoreMessage from "./PreviewMoreMessage";

interface MessagePreviewListProps {
  messages: Array<Message>;
  onClose: () => void;
  onExpand: () => void;
}

class MessagePreviewList extends React.Component<MessagePreviewListProps, {}> {
  getTruncatedMessages() {
    const { messages } = this.props;

    if (messages.length < 4) {
      return messages;
    }

    return messages.slice(Math.max(messages.length - 3, 1));
  }

  render() {
    return (
      <div role="dialog" className="velaro-preview-messages velaro-clearfix">
        <h1 className="velaro-skip">Live Chat Preview</h1>
        <PreviewCloseButton onClose={this.props.onClose} />
        <div role="button" onClick={this.props.onExpand}>
          {this.getTruncatedMessages().map(x => (
            <PreviewMessage key={x.id} message={x.text} />
          ))}
          <PreviewMoreMessage />
        </div>
      </div>
    );
  }
}

export default MessagePreviewList;
